/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Proxies_AllowedInputs */



/**
* | output |
* | --- |
* | "Proxies allowed" |
*
* @param {Tournament_Proxies_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_proxies_allowed = /** @type {((inputs?: Tournament_Proxies_AllowedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Proxies_AllowedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proxies autorisés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proxies permitidos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Proxies permitidos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proxy consentiti")
	return /** @type {LocalizedString} */ ("Proxies allowed")
});